import { Outlet } from 'react-router-dom';
// @mui
import { Box, Stack } from '@mui/material';
import { useEffect } from 'react';
import useAuth from 'src/hooks/useAuth';
import { useThemeUpdate } from 'src/theme';

// ----------------------------------------------------------------------

export default function MainLayout() {
  const { settings, setting } = useAuth();
  const { updatePalette } = useThemeUpdate();

  useEffect(() => {
    settings();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (setting) {
      const configObj = setting?.reduce((acc, item) => {
        acc[item.key] = item.value;
        return acc;
      }, {});
      updatePalette({
        primary: {
          main: configObj.PRIMARY_COLOUR,
          dark: configObj.SECONDARY_COLOUR,
          contrastText: configObj.PRIMARY_TEXT_COLOUR,
          gradient: configObj.BACKGROUND_COLOUR,
        },
      });
    }
    // eslint-disable-next-line
  }, [setting]);

  return (
    <Stack sx={{ minHeight: 1 }}>
      <Outlet />

      <Box sx={{ flexGrow: 1 }} />
    </Stack>
  );
}
